export const METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff'
export const VIEWER_SERVICE_EXTENSION_NAME = 'VIEWER_SERVICE'
// list of components that will use the svg loader feature
export const SVG_COMPONENTS_WITH_TRANSFORMATION = ['VectorImage', 'BackToTopButton'] as const
export const SVG_COMPONENTS = ['Breadcrumbs', ...SVG_COMPONENTS_WITH_TRANSFORMATION] as const
